export interface PaymentProps {
  payment_request_id: number;
  user_id: number;
  template_name: string;
  choosen_location: string;
  contragent: string;
  project: string;
  title: string;
  dogovor: string;
  request_date: string;
  total_sum: number;
  vid_oplaty: string;
  budget_summa: number;
  ostatok_budgeta: number;
  opisanie_rasxoda: string;
  first_comment: string;
  file_path: string;
  additional_info: string;
  status: number;
  pending_approver_id: number;
  creator_name: string;
  approver_name: string;
  company_id: number,
  company_name: string,
  department_id: number,
  department_name: string,
  year: number,
}

export interface PaymentListResponse {
  [key: number]: {
    data: PaymentProps[];
    total_count: number;
  };
}

export const PaymentListDefault: PaymentListResponse = {
  0: {
    data: [],
    total_count: 0,
  },
};

export interface PaymentTableResponse {
  data: PaymentProps[];
  total_count: number;
}

export const PaymentTableDefault: PaymentTableResponse = {
  data: [],
  total_count: 0,
};

export interface PaymentFilters {
  hash_pw: string | undefined;
  from_date: string | undefined;
  to_date: string | undefined;
  locations: string[] | undefined;
  template_name: string | undefined;
  contragent: string | undefined;
  project: string | undefined;
  title: string | undefined;
  dogovor: string | undefined;
  total_sum_from: number | undefined;
  total_sum_to: number | undefined;
  creator_name: string | undefined;
  approver_name: string | undefined;
  status: number[] | undefined;
  sort_by: string[] | undefined;
  limit: number | undefined;
  offset: number | undefined;
}

export const PaymentFiltersDefault: PaymentFilters = {
  hash_pw: undefined,
  from_date: undefined,
  to_date: undefined,
  locations: undefined,
  template_name: undefined,
  contragent: undefined,
  project: undefined,
  title: undefined,
  dogovor: undefined,
  total_sum_from: undefined,
  total_sum_to: undefined,
  creator_name: undefined,
  approver_name: undefined,
  status: undefined,
  sort_by: undefined,
  limit: undefined,
  offset: undefined,
};
